import React from 'react';

import cn from 'classnames';

import { SignupProgressIndicator } from './components/SignupProgressIndicator';
import styles from './SignupLayout.module.css';
import { useIsErrorStep } from './steps/useRedirectToLatestStep';
import { useCurrentPayLink } from '../Checkout/hooks/useCurrentPayLink';
import { CancelButton } from '../components/CancelButton/CancelButton';
import { HelpBox } from '../components/HelpBox/HelpBox';

export const SignupLayout = ({
  wideWidth = false,
  children,
}: {
  wideWidth?: boolean;
  children: React.ReactNode;
}) => {
  const { payLink } = useCurrentPayLink();
  const cancelUrl = payLink?.cancel_url;

  return (
    <div className={cn(styles.Signup, 'text-left')}>
      <div className="mx-auto max-w-[600px]">
        <SignupProgressIndicator />
      </div>

      <div
        className={`mx-auto ${wideWidth ? 'max-w-[720px]' : 'max-w-[600px]'}`}
      >
        <CancelButton className={styles.cancelButton} href={cancelUrl} />
        {children}
        {!useIsErrorStep() && <HelpBox />}
      </div>
    </div>
  );
};
